import { render, staticRenderFns } from "./PageAuthorization.vue?vue&type=template&id=7a4fb964"
import script from "./PageAuthorization.vue?vue&type=script&lang=ts"
export * from "./PageAuthorization.vue?vue&type=script&lang=ts"
import style0 from "./PageAuthorization.vue?vue&type=style&index=0&id=7a4fb964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports